class CustomGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this); // stop observing once triggered
        var gallery = $(this).attr("section_id");
        var swiper1 = new Swiper(".gallery-slider-1-" + gallery, {
          slidesPerView: "auto",
          spaceBetween: 22,
          freeMode: true,
          centeredSlides: true,
          speed: 9000,
          autoplay: {
            delay: 1,
          },
          loop: true,
          // allowTouchMove: false,
          // disableOnInteraction: false
        });
        var swiper2 = new Swiper(".gallery-slider-2-" + gallery, {
          slidesPerView: "auto",
          spaceBetween: 22,
          freeMode: true,
          loop: true,
          centeredSlides: true,
          speed: 9000,
          autoplay: {
            delay: 1,
            reverseDirection: true,
          },
          // allowTouchMove: false,
          // disableOnInteraction: false
        });
      },
      {
        rootMargin: "0px 0px 400px 0px",
      }
    );

    observer.observe(this);
  }
}

customElements.define("custom-gallery", CustomGallery);

class ProductSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this); // stop observing once triggered
        $(this).css({ opacity: "1" });

        new Swiper(".product-slider", {
          slidesPerView: 1,
          spaceBetween: 16,
          navigation: {
            nextEl: ".swiper-button-next--" + sectionId,
            prevEl: ".swiper-button-prev--" + sectionId,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 18,
            },
            1250: {
              slidesPerView: 3,
              spaceBetween: 18,
            },
          },
          on: {
            init: () => {
              updateSwiperParentState();
            },
            slideChange: () => {
              updateSwiperParentState();
            },
          },
        });
      },
      {
        rootMargin: "0px 0px 400px 0px",
      }
    );

    observer.observe(this);
  }
}

customElements.define("product-slider", ProductSlider);

class RelatedSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this); // stop observing once triggered
        $(this).css({ opacity: "1" });

        new Swiper(".related-slider", {
          slidesPerView: 1,
          spaceBetween: 16,
          navigation: {
            nextEl: ".swiper-button-next--" + sectionId,
            prevEl: ".swiper-button-prev--" + sectionId,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 18,
            },
            1250: {
              slidesPerView: 3,
              spaceBetween: 18,
            },
          },
          on: {
            init: () => {
              updateSwiperParentState();
            },
            slideChange: () => {
              updateSwiperParentState();
            },
          },
        });
      },
      {
        rootMargin: "0px 0px 400px 0px",
      }
    );

    observer.observe(this);
  }
}
customElements.define("related-slider", RelatedSlider);

class BrandSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.sectionId = this.getAttribute("data-sectionid");
    this.resizeHandler = this.onResize.bind(this);
  }

  connectedCallback() {
    this.initSwiperIfNeeded();
    window.addEventListener("resize", this.resizeHandler);
  }

  disconnectedCallback() {
    this.destroySwiper();
    window.removeEventListener("resize", this.resizeHandler);
  }

  onResize() {
    // Always destroy the existing instance
    this.destroySwiper();

    // Reinitialize only if screen is large enough
    if (window.innerWidth >= 990) {
      this.initSwiper();
    }
  }

  initSwiperIfNeeded() {
    if (window.innerWidth >= 990) {
      this.initSwiper();
    }
  }

  initSwiper() {
    $(this).css({ opacity: "1" });

    this.swiperInstance = new Swiper(".brand-slider", {
      slidesPerView: 1,
      spaceBetween: 24,
      grid: {
        rows: 2,
      },
      navigation: {
        nextEl: ".swiper-button-next--" + this.sectionId,
        prevEl: ".swiper-button-prev--" + this.sectionId,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        560: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1250: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
      on: {
        init: () => {
          updateSwiperParentState();
        },
        slideChange: () => {
          updateSwiperParentState();
        },
      },
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

customElements.define("brand-slider", BrandSlider);

class FaqSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({ opacity: "1" });

      const sectionId = this.getAttribute("data-sectionid");

      $(".faq-questions-" + sectionId).click(function (e) {
        e.preventDefault();
        let $this = $(this);
        if ($this.next().hasClass("show")) {
          $this.next().removeClass("show");
          $this.next().slideUp(350);
          $this.parent().removeClass("active");
          $this
            .find(".fa-chevron-arrows .fa-chevron-down")
            .css({ display: "flex" });
          $this
            .find(".fa-chevron-arrows .fa-chevron-up")
            .css({ display: "none" });
        } else {
          $(".faq-accordion-wrapper .faq-answers")
            .removeClass("show")
            .slideUp(350);
          $(".faq-accordion-wrapper").removeClass("active");
          $(".faq-accordion-wrapper .fa-chevron-arrows .fa-chevron-down").css({
            display: "flex",
          });
          $(".faq-accordion-wrapper .fa-chevron-arrows .fa-chevron-up").css({
            display: "none",
          });

          $this.next().toggleClass("show").slideToggle(350);
          $this.parent().toggleClass("active");
          $this
            .find(".fa-chevron-arrows .fa-chevron-down")
            .css({ display: "none" });
          $this
            .find(".fa-chevron-arrows .fa-chevron-up")
            .css({ display: "flex" });
        }
      });

      // Trigger click on the first question to open it by default
      const $firstQuestion = $(".faq-questions-" + sectionId).first();
      if ($firstQuestion.length) {
        $firstQuestion.trigger("click");
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("faq-section", FaqSection);

class CustomReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const self = this;
    const sectionId = self.getAttribute("data-sectionid");

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(self);
      $(self).css({ opacity: "1" });

      let swiper;
      var totalslide = $(this).find(".swiper-slide").length;

      if (window.innerWidth >= 769) {
        swiper = new Swiper(".review-slider--" + sectionId, {
          slidesPerView: 1,
          spaceBetween: 16,
          centeredSlides: true,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next--" + sectionId,
            prevEl: ".swiper-button-prev--" + sectionId,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 1,
              spaceBetween: 16,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
          on: {
            slideChangeTransitionStart: () => setSlideFadeEffect(swiper),
            init: () => setSlideFadeEffect(swiper),
          },
        });

        function setSlideFadeEffect(swiperInstance) {
          swiperInstance.slides.forEach((slide) => {
            const isActive = slide.classList.contains("swiper-slide-active");
            slide.style.opacity = isActive ? "1" : "0.4";
            slide.style.transform = isActive ? "scale(1)" : "scale(0.95)";
            slide.style.transition = "opacity 0.3s ease, transform 0.3s ease";
          });
        }
      } else {
        swiper = new Swiper(".review-slider--" + sectionId, {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          centeredSlidesBounds: true,
          loopAdditionalSlides: 0,
          loop: true,
          watchSlidesProgress: true,
          loopedSlides: totalslide,
          slideToClickedSlide: true,
          navigation: {
            nextEl: ".swiper-button-next--" + sectionId,
            prevEl: ".swiper-button-prev--" + sectionId,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
          on: {
            slideChange: function () {
              // Sometimes you might need to force update
              this.pagination.update();
            },
          },
        });
      }
    };

    new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 400px 0px",
    }).observe(self);
  }
}

customElements.define("custom-reviews", CustomReviews);

class ComplementarySliderDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.getAttribute("data-sectionid");
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this); // stop observing once triggered

        new Swiper(".complementary-products-slider-drawer", {
          slidesPerView: 1,
          spaceBetween: 16,
        });
      },
      {
        rootMargin: "0px 0px 400px 0px",
      }
    );
    observer.observe(this);
  }
}

customElements.define("complementary-slider-drawer", ComplementarySliderDrawer);

class ProductGrid extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.sectionId = this.getAttribute("data-sectionid");
    this.resizeHandler = this.onResize.bind(this);
  }

  connectedCallback() {
    this.initSwiperIfNeeded();

    // Optional: Fade in when visible
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        $(this).css({ opacity: "1" });
      },
      {
        rootMargin: "0px 0px 400px 0px",
      }
    );
    observer.observe(this);

    window.addEventListener("resize", this.resizeHandler);
  }

  disconnectedCallback() {
    this.destroySwiper();
    window.removeEventListener("resize", this.resizeHandler);
  }

  onResize() {
    this.destroySwiper();
    if (window.innerWidth <= 1024) {
      this.initSwiper();
    }
  }

  initSwiperIfNeeded() {
    if (window.innerWidth <= 1024) {
      this.initSwiper();
    }
  }

  initSwiper() {
    this.swiperInstance = new Swiper(".product-grid", {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: ".swiper-button-next--" + this.sectionId,
        prevEl: ".swiper-button-prev--" + this.sectionId,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        990: {
          slidesPerView: 2,
          spaceBetween: 18,
        },
      },
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

customElements.define("product-grid", ProductGrid);